import Nullstack from 'nullstack';
export default function IconBrandCodesandbox({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-codesandbox",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l4 -2.25l4 -2.25"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l-4 -2.25l-4 -2.25"
  }), "   ", Nullstack.element("path", {
    d: "M20 12l-4 2v4.75"
  }), "   ", Nullstack.element("path", {
    d: "M4 12l4 2l0 4.75"
  }), "   ", Nullstack.element("path", {
    d: "M8 5.25l4 2.25l4 -2.25"
  }), " ");
}